module.exports = __webpack_public_path__ + "img/4.a16bebb9.jpg";